module.exports = __webpack_public_path__ + "static/media/it-medium.74ec5748.svg";